<template>
  <div>
    <img src="@/assets/tarjeta_sorteo_freidora_2024_fin_promocion.jpg" style="width:100%" />
    <h2>SORTEO FINALIZADO</h2>
    <p>
      El sorteo se celebrará el 28 de junio según las bases legales de la promoción.
    </p>
   
    <p>
      ¡SUERTE A LOS PARTICIPANTES!
    </p>



  
     <p class="container-flex">
      <a href="https://www.mmtseguros.com/hubfs/Bases_Campanas/Bases-Promo-Sorteo-Freidora.pdf?hsLang=es-es)" target="_blank">
        <button class="pure-button botonLlamar">Consulta condiciones</button>
      </a>
    </p>
  

    

  </div>
</template>

<script>
export default {
  
  computed: {
    portfolio() {
      return this.$store.state.portfolio;
    },
  },

};
</script>

<style lang="scss" scoped>
.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
}

</style>
